import React, {useEffect, useId, useRef} from "react";
import {C} from "../styles";

export default function Modal({title, onClose, children, scrollable = false, initialFocusRef}) {
    const titleId = useId();
    const panelRef = useRef(null);

    useEffect(() => {
        function handleKeyDown(e) {
            if (e.key === "Escape") onClose();
        }
        document.addEventListener("keydown", handleKeyDown);
        return () => document.removeEventListener("keydown", handleKeyDown);
    }, [onClose]);

    useEffect(() => {
        const trigger = document.activeElement;
        (initialFocusRef?.current ?? panelRef.current)?.focus();
        return () => trigger?.focus?.();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div
            onClick={onClose}
            style={{
                position: "fixed", inset: 0, backgroundColor: "rgba(36,57,56,0.45)",
                display: "flex", alignItems: "center", justifyContent: "center",
                zIndex: 1000, padding: 16,
            }}
        >
            <div
                ref={panelRef}
                role="dialog"
                aria-modal="true"
                aria-labelledby={titleId}
                tabIndex={-1}
                onClick={e => e.stopPropagation()}
                style={{
                    backgroundColor: C.surface,
                    borderRadius: 14,
                    padding: 24,
                    maxWidth: 440,
                    width: "100%",
                    boxShadow: "0 12px 40px rgba(0,0,0,0.25)",
                    outline: "none",
                    ...(scrollable ? {maxHeight: "80vh", overflowY: "auto"} : {}),
                }}
            >
                <div style={{display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 8}}>
                    <h3 id={titleId} style={{margin: 0, fontFamily: "'Fraunces', serif", color: C.primaryDark}}>
                        {title}
                    </h3>
                    <button onClick={onClose} aria-label="Fermer" style={{background: "none", border: "none", cursor: "pointer", fontSize: 18, color: C.textMuted, lineHeight: 1}}>
                        ✕
                    </button>
                </div>
                {children}
            </div>
        </div>
    );
}
